import React, { useState } from "react";
import { useSelector } from "react-redux";

import "../../../css/createSourceModal.css";
import SwalAlertComp from "../../SwalAlert";
import LoginButton from "../../molecules/LoginButton";
import ClipLoader from "react-spinners/ClipLoader";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import {
    getB24Url,
    sendDataB24Lead,
} from "../../../helpers/Sources/b24/b24Source";

const B24LeadDestination = (props) => {
    const language = useSelector((state) => state.languagesState.languages);

    const [b24Name, setb24Name] = useState("");
    const [b24CrmUrl, setb24CrmUrl] = useState("");
    const [b24Btn, setb24Btn] = useState(false);
    const [urlError, setUrlError] = useState("");

    const [shouldRender] = useState(true);

    // Function to validate HTTPS URL
    const validateHttpsUrl = (url) => {
        if (!url) {
            return "";
        }

        try {
            const urlObj = new URL(url);
            if (urlObj.protocol !== "https:") {
                return "URL must use HTTPS protocol";
            }
            return "";
        } catch (error) {
            return "Please enter a valid URL";
        }
    };

    const sendb24Data = async (data) => {
        let newData = {
            name: b24Name,
            code: data?.code,
            crm_url: b24CrmUrl,
        };
        let response = await sendDataB24Lead(newData);
        if (response.status) {
            setb24Btn(false);
            if (props.onSuccess) {
                props.onSuccess(response?.data);
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
    };

    const handleb24Name = (e) => {
        const inputValue = e.target.value;
        setb24Name(inputValue);
    };

    const handleb24CrmUrl = (e) => {
        const inputValue = e.target.value;
        setb24CrmUrl(inputValue);

        // Validate URL on change
        const error = validateHttpsUrl(inputValue);
        setUrlError(error);

        // Only enable button if URL is valid and not empty
        setb24Btn(inputValue && !error);
    };

    return (
        shouldRender && (
            <div>
                <FormControl className="mb-3" style={{ width: "100%" }}>
                    <TextField
                        name="name"
                        label={language?.source_modal?.name ?? "Name"}
                        variant="outlined"
                        onChange={handleb24Name}
                        placeholder={
                            language?.source_modal?.please_write_name ??
                            "Please Write Name"
                        }
                        value={b24Name}
                        required
                    />
                </FormControl>

                <FormControl className="mb-3" style={{ width: "100%" }}>
                    <TextField
                        name="crm_url"
                        label={language?.source_modal?.crm_url ?? "CRM URL"}
                        variant="outlined"
                        onChange={handleb24CrmUrl}
                        placeholder={
                            language?.source_modal?.please_write_crm_url ??
                            "Please Write CRM URL (must be HTTPS)"
                        }
                        value={b24CrmUrl}
                        required
                        error={!!urlError}
                        helperText={urlError || "Enter a valid HTTPS URL"}
                    />
                </FormControl>

                <div className="position-relative overflow-hidden z-1">
                    {props.isButtonLoader !== undefined &&
                        props.isButtonLoader && (
                            <div className="circle-loader">
                                <ClipLoader color={"#000"} size={17} />
                            </div>
                        )}
                    <LoginButton
                        code="b24"
                        getAuthUrl={getB24Url}
                        getAuthUrlData={b24CrmUrl}
                        getAuthUrlResponseTransform={(response) =>
                            response?.data?.data?.url
                        }
                        onAuthUrlError={() =>
                            props?.setIsButtonLoader?.(false)
                        }
                        paramNames={["code"]}
                        onSuccess={sendb24Data}
                        dataTransform={(params) => ({ code: params.code })}
                        onLoadingChange={props?.setIsButtonLoader}
                        logoSrc="/assets/images/typeImages/b24.png"
                        buttonText={
                            language?.buttons?.connect_with_b24 ??
                            "Connect with Bitrix24"
                        }
                        disabled={!b24Btn}
                        isLoadingExternal={props?.isButtonLoader}
                    />
                </div>
            </div>
        )
    );
};

export default B24LeadDestination;
